module.exports = {
          srcSet: __webpack_public_path__ + "ae07648e1d28127558e1b5c78aa30eb7-64.png"+" 64w",
          images:[ {path: __webpack_public_path__ + "ae07648e1d28127558e1b5c78aa30eb7-64.png",width: 64,height: 64}],
          src: __webpack_public_path__ + "ae07648e1d28127558e1b5c78aa30eb7-64.png",
          toString:function(){return __webpack_public_path__ + "ae07648e1d28127558e1b5c78aa30eb7-64.png"},
          
          width: 64,
          height: 64
        }